import { Controller } from "@hotwired/stimulus"
import { parseNumber, formatNumber } from "../lib/number_helper"

export default class extends Controller {
  static targets = [
    "amountInput",
    "priceInput",
    "amountLeft",
    "destructionInput",
    "selectDelivery",
  ]

  connect() {
    this.updateSelectDeliveryCheckbox()
  }

  updateAmount() {
    const newAmount = parseNumber(this.amountInputTarget.value)

    this.amountLeftTarget.textContent = formatNumber(
      this.availableAmount() - newAmount,
    )

    this.prefillPriceInput()
    this.updateSelectDeliveryCheckbox()
  }

  updateSelectDeliveryCheckbox() {
    this.selectDeliveryTarget.checked = this.amountInputTarget.value !== ""
  }

  toggleDeliverySelection() {
    if (this.selectDeliveryTarget.checked) {
      this.amountInputTarget.value = parseNumber(
        this.amountLeftTarget.textContent,
      )
      this.amountLeftTarget.textContent = "0"
      this.prefillPriceInput()
      this.destructionInputTarget.value = "false"
    } else {
      this.amountLeftTarget.textContent = formatNumber(this.availableAmount())
      this.amountInputTarget.value = ""
      this.priceInputTarget.value = ""
      this.destructionInputTarget.value = "true"
    }
  }

  availableAmount() {
    return (
      parseNumber(this.amountLeftTarget.dataset.amountLeft) +
      parseNumber(this.amountInputTarget.dataset.initialAmount)
    )
  }

  prefillPriceInput() {
    if (!this.priceInputTarget.value) {
      this.priceInputTarget.value = parseNumber(
        this.priceInputTarget.dataset.purchasePrice,
      )
    }
  }
}
